// Accès à « Priorités de réservation » (/v1/exam-operations) : D18 (F37), le bureau suit le serveur.
// Le contrôleur n'admet que le gérant, le responsable et le secrétariat ; la lecture seule et
// l'administrateur Permio n'y ont pas accès (données personnelles du journal, CORE-18). L'onglet des Réglages,
// l'ancienne adresse et les lectures d'Aujourd'hui s'y limitent, pour ne plus produire d'appels refusés.

/** Rôles admis par le serveur sur /v1/exam-operations. */
export const EXAM_OPERATIONS_ROLES: readonly string[] = ["owner", "manager", "agent"];

/** Onglet « Priorités de réservation » de Réglages › RdvPermis et réservation (ex-/exams/preparation, 19/10/2026). */
export const PRIORITIES_PATH = "/reglages/rdvpermis?onglet=priorites";

export const canUseExamOperations = (role?: string | null) =>
  EXAM_OPERATIONS_ROLES.includes((role ?? "").toLowerCase());

/**
 * Clôture motivée d'un incident (D02) : réservée par le serveur au gérant et au responsable, qui
 * rendent la place à la vente sur la foi de leur vérification chez RdvPermis.
 */
export const canCloseExamIncidents = (role?: string | null) =>
  ["owner", "manager"].includes((role ?? "").toLowerCase());

/** Page ouverte par un rôle non admis (adresse saisie, lien ancien). */
export const EXAM_OPERATIONS_ROLE_MESSAGE =
  "Les priorités de réservation sont réservées au gérant, au responsable et au secrétariat de l’auto-école.";

/** Refus du serveur (403) malgré tout : rôle changé entre-temps, action réservée au gérant. */
export const EXAM_OPERATIONS_FORBIDDEN_MESSAGE =
  "Votre rôle ne donne pas accès aux priorités de réservation. Demandez l’accès au gérant de l’auto-école.";

/**
 * Refus de droits du serveur : 403 sans code applicatif. Les 403 porteurs d'un code (double
 * authentification, reconnexion RdvPermis) sont traités par le client HTTP et gardent leur message.
 */
export const isForbidden = (error: unknown) => {
  const response = (error as { response?: { status?: number; data?: unknown } } | null)?.response;
  if (response?.status !== 403) return false;
  const data = response.data;
  return !(typeof data === "object" && data !== null && "code" in data && (data as { code?: unknown }).code);
};
